import { Pipe, PipeTransform } from '@angular/core';

import { DateFormatPipe } from './date-format.pipe';
import { AnyProjectJobForm } from '../models/project-job-form';

@Pipe({
    name: 'templatedProjectJobFormValue',
    standalone: true,
    pure: true
})
export class TemplatedProjectJobFormValuePipe implements PipeTransform {
    dateFormat = new DateFormatPipe();

    transform(job: AnyProjectJobForm, template: string): string[] {
        return template.split('\n').map(line => line
            .replaceAll(/%title%/ig, job.title)
            .replaceAll(/%objectOmschrijvingKort%/ig, job.objectOmschrijvingKort)
            .replaceAll(/%objectOmschrijvingLang%/ig, job.objectOmschrijvingLang)
            .replace('%createdAt%', this.dateFormat.transform(job.createdAt, 'dd-MM-yyyy'))
            .replace('%createdBy%', job.createdBy || 'Systeem')
            .replace('%code%', job.code)
        ).filter(line => line.trim() !== '');
    }
}
